import type { AxiosResponse } from 'axios';
import { BaseService, ExtraMap, GET, Signal } from 'ts-retrofit3';

import type { IExtra } from '@/Module/Core/Model/ApiModel';
import { HttpService } from '@/Module/Core/Service';
import { POST_API } from '@/Module/Post/Constant';
import type { IPost } from '@/Module/Post/Model/DataModel';

class PostService extends BaseService {
  @GET(POST_API.GET_LIST)
  async getList(@Signal _signal: AbortSignal, @ExtraMap _extra?: IExtra): Promise<AxiosResponse<IPost[]>> {
    return <AxiosResponse>{};
  }
}
export default HttpService.build(PostService);
